import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "../../store/store";
import { AppDispatch } from "../../store/store";

import { changeToggle } from "../../store/scheduleStore";

import './Toggle.scss';

function ToggleSchedule() {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const { toggleCheck, selectOptions, toggleOptions } = useSelector((state: RootState) => state.schedule);

  const handleToggle = (value: string) => {
    dispatch(changeToggle({ toggle: value }));
  };

  useEffect(() => {
    if(selectOptions.length === 0) {
      return;
    }
    dispatch(changeToggle({ toggle: toggleCheck }));
    // eslint-disable-next-line
  }, [selectOptions]);

  return (
    <div className="toggle_container">
      <div className="toggle">
        {toggleOptions && toggleOptions.map((option, index) => (
          <button
            key={index}
            className={`toggle-text ${option.value} ${toggleCheck === option.value ? 'active' : ''}`}
            onClick={() => {
              if (toggleCheck !== option.value) {
                handleToggle(option.value);
              }
            }}
          >
            {t(option.label)}
          </button>
        ))}
      </div>
    </div>
  );
}

export default ToggleSchedule;